// Passos de ativação do painel. Usado pelo checklist "Primeiros passos" (AbaTutorial)
// e pelo modal de "próximo passo" que aparece depois de salvar algo (PainelAdmin).

export function lerFlag(chave) {
  try { return localStorage.getItem(chave) === '1'; } catch (e) { return false; }
}
export function gravarFlag(chave) {
  try { localStorage.setItem(chave, '1'); } catch (e) {}
}
export const chaveViu = (tenant) => `hnm_viu_agenda_${tenant?.id || ''}`;
export const chaveDivulgou = (tenant) => `hnm_divulgou_${tenant?.id || ''}`;

export function contarHorariosFuturos(horarios) {
  return (horarios || []).filter(h => {
    const d = new Date(String(h.inicio || h.data_hora_inicio || '').replace(' ', 'T'));
    return !isNaN(d) && d > new Date();
  }).length;
}

export function calcularPassos({ tenant, locais, horarios, agendamentos }) {
  const temAgendamento = (agendamentos || []).length > 0;
  return [
    {
      id: 'local', icone: 'fa-map-marker-alt',
      titulo: 'Diga onde você atende',
      desc: 'Consultório, salão, online (link do Meet/Zoom) ou a domicílio.',
      feito: (locais || []).length > 0,
      acao: 'Cadastrar local', aba: 'locais'
    },
    {
      id: 'horarios', icone: 'fa-clock',
      titulo: 'Abra seus horários',
      desc: 'Escolha os dias da semana e o início e fim do expediente. O sistema monta os horários sozinho.',
      feito: contarHorariosFuturos(horarios) > 0,
      acao: 'Abrir horários', aba: 'horarios'
    },
    {
      id: 'foto', icone: 'fa-camera',
      titulo: 'Coloque sua foto ou logo',
      desc: 'Passa mais confiança para quem abre o link pela primeira vez.',
      feito: !!tenant?.logo_url,
      acao: 'Personalizar', aba: 'personalizar', opcional: true
    },
    {
      id: 'google', icone: 'fa-calendar-alt',
      titulo: 'Conecte o Google Agenda',
      desc: 'Cada agendamento aparece no calendário do seu celular na hora.',
      feito: !!tenant?.google_access_token,
      acao: 'Conectar', aba: 'configuracoes', opcional: true
    },
    {
      id: 'ver', icone: 'fa-eye',
      titulo: 'Veja sua agenda como o cliente vê',
      desc: 'Abra o seu link e confira se está tudo certo antes de divulgar.',
      feito: lerFlag(chaveViu(tenant)) || temAgendamento,
      acao: 'Abrir minha agenda', tipo: 'ver'
    },
    {
      id: 'divulgar', icone: 'fa-share-alt',
      titulo: 'Divulgue o seu link',
      desc: 'Mande no WhatsApp para seus clientes e coloque na bio do Instagram.',
      feito: lerFlag(chaveDivulgou(tenant)) || temAgendamento,
      acao: 'Enviar no WhatsApp', tipo: 'divulgar'
    }
  ];
}

// Próximo passo sugerido: primeiro obrigatório pendente; os opcionais só depois.
export function proximoPasso(passos) {
  return passos.find(p => !p.feito && !p.opcional) || passos.find(p => !p.feito) || null;
}

// "Pronta para receber clientes" = tem local e tem horários abertos.
export function agendaPronta(passos) {
  return passos.filter(p => p.id === 'local' || p.id === 'horarios').every(p => p.feito);
}

export function mensagemCompartilhar(linkPublico) {
  return `Olá! Agora você pode marcar seu horário comigo direto pelo link, sem precisar esperar resposta: ${linkPublico}`;
}
